import styled from '@emotion/styled';
import { useState } from 'react';
import { HashLink } from 'react-router-hash-link';
import { CUSTOM_BREAK_POINT } from './Blocks/Block.styled';
type Props = {};

const FAB = (props: Props) => {
  const [scrollPercent, setScrollPercent] = useState(0);

  const checkScroll = () => {
    setScrollPercent(
      (document.body.scrollTop + document.documentElement.scrollTop) /
        (document.documentElement.scrollHeight -
          document.documentElement.clientHeight),
    );
  };

  window.addEventListener('scroll', checkScroll);
  return (
    <HashLink smooth to='/#top'>
      <FabToTop visible={scrollPercent > 0.01}>
        <SvgWrapper>
          <Svg
            className='CircularProgressbar '
            viewBox='0 0 100 100'
            data-test-id='CircularProgressbar'
            style={{ left: '0px', width: '64px', height: '64px' }}
          >
            <path
              className='CircularProgressbar-trail'
              d='
      M 50,50
      m 0,-48
      a 48,48 0 1 1 0,96
      a 48,48 0 1 1 0,-96
    '
              strokeWidth='4'
              fillOpacity='0'
              style={{
                stroke: 'white',
                strokeDasharray: '301.593px, 301.593px',
                strokeDashoffset: '0px',
              }}
            />
            <path
              className='CircularProgressbar-path'
              d='
      M 50,50
      m 0,-48
      a 48,48 0 1 1 0,96
      a 48,48 0 1 1 0,-96
    '
              strokeWidth='4'
              fillOpacity='0'
              style={{
                transition: 'stroke-dashoffset 0.1s linear 0s',
                stroke: '#ff9dea',
                strokeDasharray: '301.593px, 301.593px',
                strokeDashoffset: `${301.593 * (1 - scrollPercent)}px`,
              }}
            />
          </Svg>
          <IconWrapper>
            <Svg width='32px' height='32px' viewBox='0 0 24 24'>
              <g
                id='Web'
                stroke='none'
                strokeWidth='1'
                fill='none'
                fillRule='evenodd'
              >
                <g
                  id='[OLD-001]main'
                  transform='translate(-1836.000000, -4878.000000)'
                  fill='#ff9dea'
                >
                  <g
                    id='floating_button'
                    transform='translate(1683.000000, 4794.000000)'
                  >
                    <g
                      id='btn/top/w'
                      transform='translate(133.000000, 64.000000)'
                    >
                      <g
                        id='ico/24/top'
                        transform='translate(20.000000, 20.000000)'
                      >
                        <path
                          d='M12,2 L18.5,8.54545455 L17.0555556,10 L13,5.915 L13,22 L11,22 L11,5.915 L6.94444444,10 L5.5,8.54545455 L12,2 Z'
                          id='Combined-Shape'
                        ></path>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </Svg>
          </IconWrapper>
        </SvgWrapper>
      </FabToTop>
    </HashLink>
  );
};
const FabToTop = styled.div<{ visible: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  position: fixed;

  width: 64px;
  height: 64px;

  bottom: 80px;
  right: 140px;

  border-radius: 50%;

  opacity: ${(props) => (props.visible ? 1 : 0)};
  transition: all 1s;

  @media (max-width: ${CUSTOM_BREAK_POINT}px) {
    bottom: 2rem;
    right: 3rem;
  }
`;

const SvgWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;

const Svg = styled.svg`
  position: absolute;
`;

const IconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;

  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
`;

export default FAB;
